<template>
  <div class="header_wrap">
    <el-row class="header_row">
      <img class="logoPic" @click="handleLogo" src="/static/images/relogo.png" alt="">
      <ul class="ul_nav">
        <li @click="handleItem(item,index)" v-for="(item,index) in arrData" :key="index" :class="{'active':index==state}">{{item}}</li>
      </ul>
    </el-row>
  </div>
</template>
<script>
export default {
  name: '',
  data () { 
    return {
      // arrData:['产品首页','产品购买','付费资讯','联系我们','登录入口']
      arrData:['产品首页','产品购买','联系我们','登录入口']
    }
  },
  props:{
    state:Number
  },
  created(){},
  methods:{
    handleLogo(){
      this.$router.push({path: '/'});
    },
    handleItem(item,index){
      this.current=index;
      if(index==0){
        this.$router.push({path: '/'});
      }
      if(index==1){
        this.$router.push({path: '/purchasePage'});
      }
      // if(index==2){
      //   this.$router.push({path: '/counselPaid'});
      // }
      // if(index==3){
      //   this.$router.push({path: '/contactUs'});
      // }
      // if(index==4){
      //   window.location.href=this.oUrl.API_HOST
      // }
      if(index==2){
        this.$router.push({path: '/contactUs'});
      }
      if(index==3){
        window.location.href=this.oUrl.API_HOST
      }
    },
  }
}
</script>
<style lang="less" scoped>
*{
  font-family:PingFangHK-Regular,PingFangHK;
}
.header_wrap{
  .header_row{
    width: 100%;
    height: 1.44rem;
    padding: 0;
    margin: 0.2rem 0 0;
    position: relative;
    img.logoPic{
      width: 2.34rem;
      // height: 0.71rem;
      position: absolute;
      top: 0.36rem;
      left: 1.77rem;
      cursor: pointer;
    }
    .ul_nav{
      position: absolute;
      top: 0.4rem;
      right: 1.88rem;
      list-style: none;
      color: #333333;
      margin: 0;
      padding: 0;
      li{
        line-height: 0.46rem;
        font-size: 0.22rem;
        margin-right: 0.52rem;
        float: left;
        cursor: pointer;
      }
      li:hover,li.active{
        color: #4566F5;
      }
      li:last-child{
        margin-right: 0;
      }
    }
  }
}
@media screen and(min-width: 1680px) {
  .header_wrap{
    .header_row{
      width: 100%;
      height: 144px;
      padding: 0;
      margin: 20px 0 0;
      position: relative;
      img.logoPic{
        position: absolute;
        top: 36px;
        left: 177px;
        // height: 71px;
        width: 234px;
        cursor: pointer;
      }
      .ul_nav{
        position: absolute;
        top: 40px;
        right: 188px;
        list-style: none;
        color: #333333;
        margin: 0;
        padding: 0;
        li{
          line-height: 46px;
          font-size: 22px;
          margin-right: 52px;
          float: left;
          cursor: pointer;
        }
        li:last-child{
          margin-right: 0;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue